/* @flow */
import React from 'react';
import Typeahead from 'components/Typeahead.jsx';

class DeprecatedTypeahead extends React.Component {
  static propTypes = {
    // Function that takes a query and returns a Promise that resolves data
    // Note: There is an opportunity to create DataSource classes here.
    // (e.g., StaticDataSource, AsyncDataSource, PaginatedDataSource, etc)
    dataSource: React.PropTypes.func,
    // Function that returns a filter function to filter results
    dataFilterFactory: React.PropTypes.func,
    // Function that renders the list of results
    listRenderer: React.PropTypes.func,
    // Function that renders a result
    itemRenderer: React.PropTypes.func,
    // Function that renders a "Select all" item
    selectAllItemRenderer: React.PropTypes.func,
    // Function that renders a no more items prompt
    noMoreItemsRenderer: React.PropTypes.func,
    // Function that renders a no results prompt
    noResultsRenderer: React.PropTypes.func,
    // Show the list of results inline rather than in a layer
    inline: React.PropTypes.bool,
    // Callback when an item is selected
    onSelect: React.PropTypes.func,
    // Callback when the "Select all" item is selected
    onSelectAll: React.PropTypes.func,
  };

  static defaultProps = {
    dataSource: () => Promise.resolve([]),
    dataFilterFactory: query => {
      return datum => datum === query;
    },
    inline: false,
    onSelect: () => {},
    onSelectAll: () => {},
  };

  state = {
    query: '',
    data: [],
    results: [],
    loading: false,
  };

  componentWillMount() {
    if (this.props.inline) {
      this.loadData();
    }
  }

  setQuery(query: string = '') {
    const trimmedQuery = query.trim();
    this.setState({
      query: trimmedQuery,
      results: this.filterDataWithQuery(trimmedQuery),
    }, () => this.loadData(trimmedQuery));
  }

  handleInputFocus() {
    if (!this.state.loading && this.state.data.length === 0) {
      this.loadData(this.state.query);
    }
  }

  // typecheck: ignore statement
  handleKeyDown(event: SyntheticKeyboardEvent) {
    this.refs.typeahead.handleKeyDown(event);
  }

  updateResults() {
    const results = this.filterDataWithQuery(this.state.query);
    this.setState({
      loading: false,
      results,
    });
  }

  filterDataWithQuery(query: string) {
    const data = this.state.data.filter(this.props.dataFilterFactory(query));

    if (!query) {
      if (this.props.selectAllItemRenderer && data.length > 1) {
        data.unshift('_all');
      }
    }

    return data;
  }

  loadData(query: string = '') {
    if (query === '' && this.state.data.length > 0) {
      // the query is empty, but we're not waiting on data
      // This can be further improved by not loading whenever the query truncated by delete key
      this.updateResults();
      return;
    }

    this.setState({ loading: true });
    this.props.dataSource(query).then(data => {
      this.setState({ data }, this.updateResults);
    }).catch(err => console.error('Data source query failure', err));
  }

  render() {
    return (
      <Typeahead
        ref="typeahead"
        className={this.props.className}
        inline={this.props.inline}
        query={this.state.query}
        results={this.state.results}
        itemRenderer={this.props.itemRenderer}
        listRenderer={this.props.listRenderer}
        selectAllItemRenderer={this.props.selectAllItemRenderer}
        noMoreItemsRenderer={this.props.noMoreItemsRenderer}
        noResultsRenderer={this.props.noResultsRenderer}
        onSelect={this.props.onSelect}
        onSelectAll={() => this.props.onSelectAll(this.state.data)}>
        {React.cloneElement(this.props.children, { onFocus: () => this.handleInputFocus() })}
      </Typeahead>
    );
  }
}

export default DeprecatedTypeahead;



// WEBPACK FOOTER //
// ./src/components/DeprecatedTypeahead.jsx